import Spinner from '../components/Spinner';
import { AppHeaderBackButton } from '@ace-clublabs/shared-component-library';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClubHelper } from '@ace-clublabs/payments-helper';
import { sources } from '../api/sources';
import UpdateEmailsForm from '../components/UpdateEmailsForm';
import { useGlobalState } from '../shared/state';
import { UtagHelper } from '../utils/utagHelper';
import { mapMembershipLevelForTagging } from '@lib/shared';
import { AppFlow, ErrorType } from '@lib/types';
import { ClubCodes } from '@ace-clublabs/payment-types';
import { Pages } from '../shared/pages';

const UpdateEmailsPage: React.FC = () => {
  const [emailOnFile] = useGlobalState('emailOnFile');
  const [zipCode] = useGlobalState('zipCode');
  const [amountDue] = useGlobalState('amountDue');
  const [campaignCode] = useGlobalState('campaignCode');
  const [membershipNumber] = useGlobalState('membershipNumber');
  const [membershipLevel] = useGlobalState('membershipLevel');
  const [autoPay] = useGlobalState('autoPayEnrolled');
  const [optedDiscount] = useGlobalState('optedDiscount');
  const [autoPayEligibility] = useGlobalState('autoPay');
  const [clubCode] = useGlobalState('clubCode');
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const onClickBack = () => navigate(-1);
  const { eligible, discount } = autoPayEligibility || {};
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [appFlow] = useGlobalState('appFlow');
  const [tagging, setIsTagging] = useState(true);
  const [brokerRegion] = useGlobalState('brokerRegion');

  useEffect(() => {
    const mem_autopaycampaign = eligible && discount ? 'autopay required' : 'autopay not required';
    const page = emailOnFile ? UtagHelper.Pages(appFlow).emailOnFile : UtagHelper.Pages(appFlow).emailNotOnFile;
    const mem_level = mapMembershipLevelForTagging(membershipLevel);

    const tags =
      appFlow === AppFlow.AUTOPAY
        ? {}
        : {
            mem_autopaycampaign,
            bill_status: amountDue > 0 ? 'due' : 'not due',
            campaigncodemr: campaignCode,
            mem_autopay: `${eligible}`,
          };

    UtagHelper.tag({
      ...UtagHelper.CommonTaggingValues(appFlow),
      ...tags,
      club: ClubHelper.getClubAcronym(clubCode as ClubCodes),
      page,
      mem_level,
    });

    setIsTagging(false);
  }, []);

  useEffect(() => {
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    });

    return () => {
      window.removeEventListener('pageshow', () => {});
    };
  }, []);

  const handleContinue = async (values: any) => {
    const primaryEmail = values['primaryEmail'] || undefined;
    const secondaryEmail = values['secondaryEmail'] || undefined;
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    const appFlow = pathname.includes('/autopay-enrollment/') ? AppFlow.AUTOPAY : AppFlow.PAYMENT;

    const apiBody = {
      zipCode,
      membershipNumber,
      primaryEmail,
      secondaryEmail,
    };

    try {
      setLoading(true);
      const apiCalls: Promise<any>[] = [
        sources.createManifest({
          membershipNumber,
          zipCode,
          autoPay,
          optedDiscount,
          appFlow,
          brokerRegion,
        }),
      ];

      if (primaryEmail || secondaryEmail) {
        apiCalls.push(sources.updateEmails(apiBody));
      }

      const [manifestRes] = await Promise.all(apiCalls);
      const { manifestId } = manifestRes;
      let uri = `https://${hostname}/payments/${manifestId}`;

      if (isMobileApp) {
        uri += '?mobileapp=true';
      }

      window.location.assign(uri);
    } catch (e) {
      setLoading(false);
      navigate(Pages.Error, { state: { errorType: ErrorType.SYSTEM_ERROR } });
    }
  };

  if (tagging) {
    return <></>;
  }

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      {!isMobileApp && <AppHeaderBackButton id="back-button" onClick={onClickBack} />}
      <UpdateEmailsForm handleContinue={handleContinue} primaryEmail={emailOnFile} />
    </>
  );
};

export default UpdateEmailsPage;
